import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

function DialogFooter({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", className)} {...props} />;
}

export { DialogFooter };
